module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/129hRur/tc-custom/9781646560370.jpg?1723406656543",
      "alt": "This image is the cover for the book Ghosts of Honor"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ghosts of Honor\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Goose and Patrick are getting married! One year after their courtship began, months after facing death, the family is expanding, and the pair can’t wait to exchange vows, happy to have the legal right to do so, when others did not. Wedding plans ensue, but all is not well."), _c('br'), _c('br'), _vm._v("For starters, Jefferson and Daniel are still separated, stranded on Earth as other people. As Patrick deals with the physical and mental aftereffects of his attack, Goose becomes obsessed with reuniting his favorite pair of angels. As if that wasn’t enough, more ghosts begin to appear to Goose and Patrick, setting off a new mystery both become consumed with solving."), _c('br'), _c('br'), _vm._v("Who are these spirits desperate for contact? How do they tie back to Jefferson and Daniel, and will Goose and Patrick be able to bring that pair back together? Will the wedding go on if they can’t?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David Connor, E.F. Mulder\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0